import { Component, OnInit } from '@angular/core';
import * as Highcharts from 'highcharts';
import Chart from 'chart.js';
import { OnboardingService } from '../../../../shared/services/onboarding.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { KycService } from 'src/app/shared/services/kyc.service';

@Component({
    selector: 'app-risk-profile',
    templateUrl: './risk-profile.component.html',
    styleUrls: ['./risk-profile.component.scss'],
})
export class RiskProfileComponent implements OnInit {
    options: any = {
        chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie',
        },
        title: {
            text: '',
        },
        credits: {
            enabled: false,
        },
        tooltip: {
            pointFormat: '<br>{point.percentage:.1f} %',
        },
        plotOptions: {
            pie: {
                dataLabels: {
                    enabled: true,
                    format: '<h3>{point.percentage:.1f}%</h3><br>{point.name}',
                },
            },
        },
        series: [
            {
                colorByPoint: true,
                data: [
                    {
                        name: 'Equity',
                        y: 34,
                        color: '#B8DCFB',
                    },
                    {
                        name: 'Bonds',
                        y: 58,
                        color: '#FFC893',
                    },
                    {
                        name: 'Cash',
                        y: 2,
                        color: '#ABDFC7',
                    },
                    {
                        name:'Real Estate',
                        y:5,
                        color: '#e9ecef'

                    }
                ],
                innerSize: '75%',
            },
        ],
    };
    lineOptions: any = {
        type: 'bar',
      
        options: {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
                display: false,
            },
            tooltips: {
                mode: 'index',
                intersect: false,
                titleFontColor: '#2da5ec',
                bodyFontColor: '#2da5ec',
                titleFontSize: 8,
                bodyFontSize: 10,
                // backgroundColor: 'transparent',
                xPadding: 8,
                yPadding: 5,
                displayColors: false,
            },
            elements: {
                line: {
                    borderColor: 'transparent',
                    borderWidth: 3,
                },
                point: {
                    radius: 0,
                },
            },
            scales: {
                yAxes: [
                    {
                        display: true,
                        
                    },
                ],
                xAxes: [
                    {
                        display: true,
                       
                    },
                ],
            },
        },
    };
    paymentMethods = [
        {
            title: 'Equities',
            id: 1,
        },
        {
            title: 'Bonds',
            id: 2,
        },
        {
            title: 'Cash',
            id: 3,
        },
        {
            title: 'Real',
            id: 4,
        }
    ];
    profiles = [
        {
            name: 'Conservative',
            percentage: 8,
            bond:58,
            GOVT:18,
            IGOV:12,
            CORP:15,
            BNDX:13,
            equity:34,
            VTI:10,
            IDEV:18,
            IEMG:6,
            cash:5,
            real:3,
            RWO:3,
            description:
                'Our Conservative portfolio is our Low risk portfolio focused on investment in fixed income assets which tend to have lower levels of risk through all market conditions. There is still some exposure to growth assets such as equities but we maintain the right mix to ensure the focus is on preservation of value.',
            text: 'Low',
            color: 'purple',
            id: 1,
            backgroundColor: '#735DD0',
            data: [
                7.20,
                -0.24,
                5.36,
                10.96,
                -3.30,
                15.95,
                4.08
            ]
        },
        {
            name: 'Balanced',
            percentage: 12,
            bond:33,
            GOVT:7,
            IGOV:6,
            CORP:10,
            BNDX:10,
            equity:34,
            VTI:31,
            IDEV:21,
            IEMG:8,
            cash:2,
            real:5,
            RWO:5,
            description:
                'Our Balanced portfolio is our medium risk portfolio focused on investment in fixed income assets which tend to have lower levels of risk through all market conditions. There is still some exposure to growth assets such as equities but we maintain the right mix to ensure the focus is on preservation of value.',
            text: 'Medium',
            color: 'green',
            id: 2,
            backgroundColor: '#47B881',
            data: [
                7.33,
                -0.43,
                5.98,
                13.33,
                -4.39,
                18.06,
                2.58
            ]
        },
        {
            name: 'Growth',
            percentage: 18,
            bond:2,
            GOVT:18,
            IGOV:3,
            CORP:5,
            BNDX:5,
            equity:34,
            VTI:37,
            IDEV:28,
            IEMG:13,
            cash:2,
            real:5,
            RWO:5,
            description:
                'Our Growth portfolio is our High risk portfolio focused on investment in fixed income assets which tend to have lower levels of risk through all market conditions. There is still some exposure to growth assets such as equities but we maintain the right mix to ensure the focus is on preservation of value.',
            text: 'High',
            color: 'blue',
            id: 3,
            backgroundColor:'rgba(50,150,200,1.3)',
            data: [
                6.51,
                -0.80,
                6.97,
                17.44,
                -5.98,
                21.09,
                0.97
            ]
        },
    ];
    activeProfile: number;
    tabs = [
        {
            name: 'Global',
            active: true,
        },
        {
            name: 'Local',
            active: false,
        },
    ];
    activeTab = 1;
    activeMethod = 0;
    result: string;
    gbond: number;
    riskType: string;
    advisoryObject:any ={};
    dataValue: {} = {};
    errMsg: string;
    error:boolean;

    // Computed Properties
    get currentProfile() {
        if (this.activeProfile){
            this.gbond = this.profiles[this.activeProfile - 1].bond;
            this.dataValue = this.profiles[this.activeProfile - 1];
            
            return this.profiles[this.activeProfile - 1];
        }
        else
        return {};
    }

    changeTab(index) {
        this.tabs.map((el) => (el.active = false));
        this.tabs[index].active = true;
    }

    toggleAccordion(id) {
        if (this.activeMethod === id) this.activeMethod = 0;
        else {
            this.activeMethod = id;
        }
    }

    // updateRiskProfile(){
    //     this.advisoryObject["portfolioType"]="CONSERVATIVE";
    //     this.kyc.updateKYC(this.advisoryObject)
    //         .subscribe((res:any)=>{
    //             console.log('riskprofile',res);
    //         })
    // }

    getProfile() {
        this.SpinnerService.show();
        this.kyc.getProfile().subscribe((res: any) => {
            if (res.code == 200 && res.success === true) {
                this.riskType = res.data.portfolioType;
                console.log(this.riskType,'rislll')
             switch (res.data.portfolioType){
                 case 'CONSERVATIVE':
                     this.activeProfile = 1;
                     this.currentProfile
                     this.generateLineChart(this.dataValue);
                     break;
                case 'BALANCED':
                    this.activeProfile = 2;
                    this.currentProfile;
                    this.generateLineChart(this.dataValue);
                    break;
                case 'GROWTH':
                    this.activeProfile = 3;
                    this.currentProfile;
                    this.generateLineChart(this.dataValue);
                    break;
                default:
                this.activeProfile = 1;
                this.currentProfile;
                this.generateLineChart(this.dataValue);
                break;
             }

            } else {
                this.activeProfile = 0;
                this.error = true;
                this.errMsg ='You have not been allocated any portfolio as you have no calculated risk profile. Please complete the onboarding process'
            }
            this.SpinnerService.hide();
        },err=>{
            this.SpinnerService.hide();
            this.error = true;
            this.errMsg=err.error.message;
            if(this.errMsg === undefined)
                this.errMsg = 'Network Error. Please check your connectivity.'
        });
    }

    getBgColor(color: string) {
        return `${color}-bg`;
    }

    generateLineChart(data) {
        const canvas = document.getElementById(
            'lineChart'
        ) as HTMLCanvasElement;
        const ctx = canvas.getContext('2d');

        const chart = new Chart(ctx, {
            ...this.lineOptions,
            data: {
                labels: [
                    '2014',
                    '2015',
                    '2016',
                    '2017',
                    '2018',
                    '2019',
                    '2020',
                    
                ],
                datasets: [
                    {   
                        data:data.data,
                        barPercentage: 0.5,
                        barThickness: 30,
                        maxBarThickness: 8,
                        minBarLength: 2,
                        borderColor: 'rgba(75, 192, 192, 1)',
                        backgroundColor: data.backgroundColor,
                        fill: false,
                    },
                ],
            },
        
        });
    }

    setActive(id: number) {
        this.activeProfile = id;
        console.log(this.activeProfile,'setActive')
    }

    constructor(
        private api: OnboardingService,
        private kyc: KycService,
        private SpinnerService: NgxSpinnerService
    ) {}

    ngOnInit() {
        let chart1 = Highcharts.chart('container', this.options);
        
         this.getProfile();
   
    }
}
